/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { getTestAttributes, slug } from '@chillibean/component-library';
import PropTypes from 'prop-types';

export function OtherFieldOption(props) {
  const {
    otherChecked,
    handleOtherClick,
    fieldId,
    handleOtherOptionChange,
    value,
    placeholder,
    displayOtherField,
    otherFieldLabel,
    fieldTitle = '',
  } = props;

  return (
    <>
      <div className="form__field form__options-grid-child">
        <input
          id="other-option-input-radio"
          type="radio"
          value={otherFieldLabel}
          className="form__control form__control--radio"
          checked={otherChecked}
          onChange={() => {}}
        />

        <label
          htmlFor="other-option-input-radio"
          onClick={handleOtherClick}
          id={`other-option-input-radio-${slug(fieldTitle)}`}
          {...getTestAttributes(`other-option-input-radio-${slug(fieldTitle)}`)}
        >
          <span>{otherFieldLabel}</span>
        </label>
      </div>
      <div className="form__field">
        <div className="form__field_other_field" style={{ maxHeight: displayOtherField ? '50px' : 0 }}>
          <input
            type="text"
            id={`radio_other_input_${slug(fieldTitle)}`}
            style={{
              paddingTop: '15px',
              transition: '0.3s ease-in-out',
            }}
            className="form__control"
            placeholder={placeholder}
            onChange={(event) => handleOtherOptionChange(fieldId, event.target.value)}
            value={value || ''}
            {...getTestAttributes(`radio-other-input-${slug(fieldTitle)}`)}
          />
        </div>
      </div>
    </>
  );
}

export default OtherFieldOption;

OtherFieldOption.propTypes = {
  otherChecked: PropTypes.bool,
  handleOtherClick: PropTypes.func,
  fieldId: PropTypes.string,
  handleOtherOptionChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  displayOtherField: PropTypes.bool,
  otherFieldLabel: PropTypes.string,
  fieldTitle: PropTypes.string,
};
